import { createSlice } from "@reduxjs/toolkit";
import {
    setAccessToken,
    getSessionExpiry,
    setSessionExpiry,
    clearAuth,
} from "../../Util/authStorage.js";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        token: null,              // short-lived access token (held in memory only)
        refreshExpiresAt: getSessionExpiry() ?? null,
        user: null,
    },

    reducers: {
        loginSuccess: (state, action) => {
            state.token             = action.payload.token;
            state.refreshExpiresAt  = action.payload.refreshExpiresAt ?? null;
            state.user              = action.payload.user;
            setAccessToken(action.payload.token);
            if (action.payload.refreshExpiresAt) {
                setSessionExpiry(action.payload.refreshExpiresAt);
            }
        },
        // Called when silent-refresh succeeds — updates ONLY the in-memory access
        // token. Session expiry is ABSOLUTE (fixed at login), so a refresh must
        // never touch refreshExpiresAt / vcplsessionexpiry: the countdown stays
        // anchored to the login-time deadline and never resets on refresh/new tab.
        refreshSuccess: (state, action) => {
            state.token = action.payload.token;
            setAccessToken(action.payload.token);
        },
        logout: (state) => {
            state.token            = null;
            state.refreshExpiresAt = null;
            state.user             = null;
            clearAuth();
        },
    },
});

export const { loginSuccess, refreshSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
